import { useQuery } from 'react-query';
import { getPage } from '../../../service';

function FooterInfo() {

  const isEnglish = window.__LANG__ === 'en';

  const { isLoading, error, data } = useQuery('getPage', () => getPage(isEnglish ? 'footer-info-en' : 'footer-info'));

  return (
    <>
    {
      !isLoading && !error && data && (
        <p dangerouslySetInnerHTML={ {__html: data.content.rendered } } />
      )
    }    
    </>
  );
}

FooterInfo.defaultProps = {
};

export default FooterInfo;
